import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionWrapper, FadeIn } from './Shared';
export const Testimonials = () => {
  const testimonials = [{
    quote: 'Pensé que era normal vivir hinchada. Con Deshinchate entendí lo que me pasaba y en días ya me sentía más liviana.',
    name: 'Carla M.'
  }, {
    quote: 'Probé mil cosas antes. Esto fue lo único que me dio claridad real.',
    name: 'Sofía R.'
  }, {
    quote: 'Lo mejor es que es simple. No es otra dieta imposible.',
    name: 'Mariana L.'
  }];
  return <SectionWrapper className="bg-cream" data-id="element-157">
      <div className="text-center max-w-3xl mx-auto mb-8 md:mb-16" data-id="element-158">
        <FadeIn data-id="element-159">
          <span className="text-4xl mb-4 block" data-id="element-160">💬</span>
          <h2 className="text-3xl md:text-4xl font-bold text-sage-900 mb-4" data-id="element-161">
            Lo que dicen otras mujeres
          </h2>
        </FadeIn>
      </div>

      <div className="grid md:grid-cols-3 gap-4 md:gap-8 max-w-5xl mx-auto" data-id="element-162">
        {testimonials.map((test, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-163">
            <div className="bg-white p-5 md:p-8 rounded-2xl md:rounded-3xl shadow-soft border border-sage-50 h-full flex flex-col" data-id="element-164">
              <div className="flex text-yellow-400 mb-6" data-id="element-165">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-166" />)}
              </div>
              <p className="text-slate-700 italic mb-6 flex-grow text-lg leading-relaxed" data-id="element-167">
                "{test.quote}"
              </p>
              <p className="font-bold text-sage-900" data-id="element-168">— {test.name}</p>
            </div>
          </FadeIn>)}
      </div>
    </SectionWrapper>;
};